import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function FloatLabel(props) {
    const { hasError, label, className, isOpen, highlight, size = 'normal', ...htmlProps } = props;

    if (!label) {
        return null;
    }

    return (
        <label
            className={cn(
                "absolute z-[1] flex -top-[1px] left-2.5 max-w-[calc(100%-(--spacing(6)))] -translate-y-1/2 before:content-[''] before:absolute before:left-0 before:top-[calc(50%+3px)] before:-translate-y-1/2 before:w-full before:h-[4px] text-gray-400 before:bg-white group-focus-within:text-primary group-focus-within:before:top-1/2 before:transition-all",
                !isOpen && hasError && 'text-danger',
                isOpen && !highlight && 'text-primary before:top-1/2',
                highlight && 'text-warning before:top-1/2 group-focus-within:text-warning',
                className,
            )}
            data-float-label
            {...htmlProps}
        >
            <span
                className={cn('relative inline-block px-1.5 text-sm truncate', {
                    'text-xs': size === 'small',
                    'text-sm': size === 'normal',
                })}
            >
                {label}
            </span>
        </label>
    );
}

FloatLabel.propTypes = {
    className: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    isOpen: PropTypes.bool,
    hasError: PropTypes.bool,
    highlight: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'normal']),
};
